<template>
    <v-container class="pa-12 fill-height align-start" fluid>
        <div class="d-flex justify-space-between align-center">
            <div class="headline">Topics</div>
        </div>
        <v-row>
            <v-col cols="12" md="6" class="d-flex align-center py-4">
                <v-card width="460" flat color="grey lighten-4">
                    <v-card-text>
                        <div class="d-flex align-center">
                            <v-text-field
                                dense
                                outlined
                                hide-details
                                label="New topic name"
                                v-model="newTopicName"
                                class="mr-4"
                            ></v-text-field>
                            <v-btn
                                small
                                depressed
                                color="primary"
                                @click="createTopic"
                                :disabled="!newTopicName"
                            >Save</v-btn>
                        </div>
                    </v-card-text>
                </v-card>                    
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-chip
                    outlined
                    color="primary"
                    class="mr-4"
                    v-for="(topic, index) in topics"
                    :key="index"
                    v-text="topic.name"
                    @click="updateTopicEventHandler(topic)"
                ></v-chip>
            </v-col>
        </v-row>
        <!-- Update level bottom sheet -->
        <v-bottom-sheet v-model="updateTopicSheet">
            <v-sheet class="py-4 text-center">                
                <v-row no-gutters justify="center" class="py-3">
                    <v-col cols="12" md="6" lg="4">
                        <v-text-field
                            dense
                            outlined
                            hide-details
                            label="Topic"
                            v-model="topicObject.name"
                        ></v-text-field>
                        <div class="d-flex mt-4">
                            <v-btn 
                                depressed 
                                small 
                                color="primary"
                                @click="updateTopic"
                            >Update</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn
                                depressed 
                                small 
                                color="secondary"
                                @click="deleteTopic"
                            >Delete</v-btn>
                        </div>
                    </v-col>                                           
                </v-row>              
            </v-sheet>
        </v-bottom-sheet>
    </v-container>
</template>

<script>
    export default {
        name: 'creativeTopics',
        data: () => ({
            topics: [],
            newTopicName: '',
            topicObject: {
                name: ''
            },
            updateTopicSheet: false,
            loading: false
        }),
        mounted() {
            this.fetchTopics()
        },
        methods: {
            async fetchTopics() {
                await this.axios.get('/Topic/GetAllTopics', {
                    params: {
                        languageId: 1
                    }
                })
                .then(response => {
                    this.topics = response.data
                })
            },
            createTopic() {
                const data = {
                    name: this.newTopicName,
                    languageId: 1
                }
                this.axios.post('Topic/CreateTopic', data)
                .then(response => {
                    this.topics.push(response.data)
                    this.newTopicName = ''
                })
                .catch(error => {
                    const snackbar = {
                        show: true,
                        message: error.message
                    }
                    this.$EventBus.$emit('snackbar', snackbar)
                })
            },
            updateTopicEventHandler(topic) {
                this.updateTopicSheet = true
                this.topicObject.id = topic.id
                this.topicObject.name = topic.name
                this.topicObject.languageId = topic.languageId
            },
            updateTopic() {
                const data = {
                    id: this.topicObject.id,
                    name: this.topicObject.name,
                    languageId: this.topicObject.languageId
                }
                this.axios.post('/Topic/UpdateTopic', data)
                .then(response => {
                    let index = this.topics.map(topic => {
                        return topic.id
                    }).indexOf(this.topicObject.id)
                    this.topics[index] = response.data
                    this.clearTopicObject()
                })
                .catch(error => {
                    const snackbar = {
                        show: true,
                        message: error.message
                    }
                    this.$EventBus.$emit('snackbar', snackbar)
                })
            },
            deleteTopic() {
                this.axios.delete('/Topic/DeleteTopic', {
                    params: {
                        id: this.topicObject.id
                    }
                })
                .then(response => {
                    let index = this.topics.map(topic => {
                        return topic.id
                    }).indexOf(this.topicObject.id)
                    this.topics.splice(index, 1)
                    const snackbar = {
                        show: true,
                        message: 'Topic successfully deleted'
                    }
                    this.$EventBus.$emit('snackbar', snackbar)
                    this.clearTopicObject()
                })
                .catch(error => {
                    const snackbar = {
                        show: true,
                        message: error.message
                    }
                    this.$EventBus.$emit('snackbar', snackbar)
                })
            },
            clearTopicObject() {
                this.topicObject.id = null
                this.topicObject.name = ''
                this.updateTopicSheet = false
            }
        }
    }
</script>

<style lang="scss" scoped></style>